module.exports = __webpack_public_path__ + "static/media/aw-whistledog-dt-en.2e4007e4.jpg";